// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".full-width[data-v-5d1ba760]{position:relative;height:100%;min-width:320px}.full-width[data-v-5d1ba760]:after{content:\"\";min-width:320px;display:block;position:absolute;background-color:#cc7edf;height:100%;width:100vw;top:50%;left:50%;transform:translate(-50%, -50%);z-index:-1;min-width:320px}.full-width.light[data-v-5d1ba760]:after{background-color:#f9f8fa}.full-width.hidden[data-v-5d1ba760]:after{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
